export default {
  title: 'Daftar Voucher Aktif',
  subtitle: 'Voucher yang tersedia dan masih berlaku',
  searchLabel: 'Cari Voucher',
  searchPlaceholder: 'Cari berdasarkan nama atau kode voucher...',
  emptyStateTitle: 'Tidak ada voucher tersedia',
  emptyStateSubtitle: 'Voucher akan muncul di sini ketika tersedia',
  table: {
    courier: 'Kurir',
    voucherName: 'Nama Voucher',
    voucherCode: 'Kode Voucher',
    discount: 'Diskon',
    maxDiscount: 'Maks. Diskon',
    quota: 'Kuota',
    period: 'Periode Berlaku',
    action: 'Aksi'
  },
  allCourier: 'Semua Kurir',
  periodStart: 'Mulai:',
  periodEnd: 'Berakhir:',
  orderButton: 'Pesan',
  pagination: {
    previous: 'Sebelumnya',
    next: 'Selanjutnya',
    showing: 'Menampilkan',
    to: '-',
    of: 'dari',
    vouchers: 'voucher'
  }
}
